import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EmailInBioChange } from '../../models/emailInBioChange';
import { EmailInBioChangeService } from '../../services/email-in-bio-change.service';
import { genreColorClass } from '../../utils/genre-colors';

@Component({
  selector: 'app-email-in-bio-changes',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './email-in-bio-changes.component.html',
  styleUrls: ['./email-in-bio-changes.component.css']
})
export class EmailInBioChangesComponent implements OnInit {
  selectedDate: string = '';
  emailInBioChanges: EmailInBioChange[] = [];
  loading: boolean = false;
  errorMessage: string = '';

  genreColorClass = genreColorClass;

  constructor(private emailInBioChangeService: EmailInBioChangeService) {}

  ngOnInit(): void {
    // Do not load data on init - wait for user to select a date
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  onDateChange(): void {
    if (this.selectedDate) {
      this.loadEmailInBioChanges();
    }
  }

  loadEmailInBioChanges(): void {
    this.loading = true;
    this.errorMessage = '';
    this.emailInBioChangeService.getEmailInBioChanges(this.selectedDate).subscribe({
      next: (data) => {
        this.emailInBioChanges = data;
        this.loading = false;
      },
      error: (error) => {
        this.errorMessage = 'Failed to load email in bio changes';
        console.error('Error loading email in bio changes:', error);
        this.loading = false;
      }
    });
  }

  getGenreString(genreNumber: number): string {
    const genres = [
      'Food',
      'Finance',
      'Lifestyle',
      'Beauty',
      'Tech',
      'Gaming',
      'Travel',
      'Entertainment',
      'Running',
      'Pets',
      'Fashion',
      'Fitness',
      'Comedy',
      'Family',
      'Other'
    ];
    return genres[genreNumber] || 'Unknown';
  }

  openTikTokProfile(handle: string): void {
    // Remove @ if it exists in the handle
    const cleanHandle = handle.startsWith('@') ? handle.substring(1) : handle;
    window.open(`https://tiktok.com/@${cleanHandle}`, '_blank');
  }
}
